import { Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/public/LandingPage';
import { PricingPage } from './pages/public/PricingPage';
import { ComparePage } from './pages/public/ComparePage';
import { NotFoundPage } from './pages/public/NotFoundPage';
import { DemoPage } from './pages/public/DemoPage';
import { SharedSnapshotPage } from './pages/public/SharedSnapshotPage';
import { UnsubscribePage } from './pages/public/UnsubscribePage';
import {
  SecurityPage,
  TrustPage,
  StatusPage,
  ChangelogPage,
  TermsPage,
  PrivacyPage,
} from './pages/public/LegalPages';
import { AboutPage } from './pages/public/AboutPage';
import { CareersPage } from './pages/public/CareersPage';
import { ContactPage } from './pages/public/ContactPage';
import { PressPage } from './pages/public/PressPage';
import { CookiePolicyPage } from './pages/public/CookiePolicyPage';
import { DpaPage } from './pages/public/DpaPage';
import { SubprocessorsPage } from './pages/public/SubprocessorsPage';
import { TokushohoPage } from './pages/public/TokushohoPage';
import { AcceptableUsePage } from './pages/public/AcceptableUsePage';
import { OpenSourcePage } from './pages/public/OpenSourcePage';
import { LoginPage } from './pages/auth/LoginPage';
import { SignupPage } from './pages/auth/SignupPage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage';
import { VerifyEmailPage } from './pages/auth/VerifyEmailPage';
import { OnboardingPage } from './pages/onboarding/OnboardingPage';
import { AppHome } from './pages/app/AppHome';
import { ProfilePage } from './pages/app/ProfilePage';
import { SignalFeedPage } from './pages/app/SignalFeedPage';
import { PeoplePage } from './pages/app/PeoplePage';
import { CompaniesPage } from './pages/app/CompaniesPage';
import { DealsPage } from './pages/app/DealsPage';
import { SequencesPage } from './pages/app/SequencesPage';
import { MeishiPage } from './pages/app/MeishiPage';
import { AgentsPage } from './pages/app/AgentsPage';
import { AiResultsPage } from './pages/app/AiResultsPage';
import { SettingsPage } from './pages/app/SettingsPage';
import { AssignmentRulesPage } from './pages/app/AssignmentRulesPage';
import { ApprovalsPage } from './pages/app/ApprovalsPage';
import { AuditLogPage } from './pages/app/AuditLogPage';
import { SharedLinksPage } from './pages/app/SharedLinksPage';
import { InboxPage } from './pages/app/InboxPage';
import { ReportsPage } from './pages/app/ReportsPage';
import { BulkImportPage } from './pages/app/BulkImportPage';
import { ConnectorsPage } from './pages/app/ConnectorsPage';
import { AdminStatsPage } from './pages/admin/AdminStatsPage';
import { AdminUsersPage } from './pages/admin/AdminUsersPage';
import { AdminCompaniesPage } from './pages/admin/AdminCompaniesPage';
import { AdminAiRunsPage } from './pages/admin/AdminAiRunsPage';
import { AdminAiSpendPage } from './pages/admin/AdminAiSpendPage';
import { AdminAuditPage } from './pages/admin/AdminAuditPage';

export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/compare" element={<ComparePage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/share/:id" element={<SharedSnapshotPage />} />
      <Route path="/unsubscribe" element={<UnsubscribePage />} />
      <Route path="/security" element={<SecurityPage />} />
      <Route path="/trust" element={<TrustPage />} />
      <Route path="/status" element={<StatusPage />} />
      <Route path="/changelog" element={<ChangelogPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/press" element={<PressPage />} />
      <Route path="/cookies" element={<CookiePolicyPage />} />
      <Route path="/dpa" element={<DpaPage />} />
      <Route path="/subprocessors" element={<SubprocessorsPage />} />
      <Route path="/tokusho" element={<TokushohoPage />} />
      <Route path="/acceptable-use" element={<AcceptableUsePage />} />
      <Route path="/open-source" element={<OpenSourcePage />} />

      {/* Auth */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/register" element={<SignupPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />

      {/* App */}
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route path="/app" element={<AppHome />} />
      <Route path="/app/profile" element={<ProfilePage />} />
      <Route path="/app/workspace/:wsId" element={<SignalFeedPage />} />
      <Route path="/app/workspace/:wsId/feed" element={<SignalFeedPage />} />
      <Route path="/app/workspace/:wsId/people" element={<PeoplePage />} />
      <Route path="/app/workspace/:wsId/companies" element={<CompaniesPage />} />
      <Route path="/app/workspace/:wsId/deals" element={<DealsPage />} />
      <Route path="/app/workspace/:wsId/sequences" element={<SequencesPage />} />
      <Route path="/app/workspace/:wsId/inbox" element={<InboxPage />} />
      <Route path="/app/workspace/:wsId/reports" element={<ReportsPage />} />
      <Route path="/app/workspace/:wsId/bulk-import" element={<BulkImportPage />} />
      <Route path="/app/workspace/:wsId/meishi" element={<MeishiPage />} />
      <Route path="/app/workspace/:wsId/agents" element={<AgentsPage />} />
      <Route path="/app/workspace/:wsId/ai-results" element={<AiResultsPage />} />
      <Route path="/app/workspace/:wsId/settings" element={<SettingsPage />} />
      <Route path="/app/workspace/:wsId/connectors" element={<ConnectorsPage />} />
      <Route
        path="/app/workspace/:wsId/assignment-rules"
        element={<AssignmentRulesPage />}
      />
      <Route path="/app/workspace/:wsId/approvals" element={<ApprovalsPage />} />
      <Route path="/app/workspace/:wsId/audit-log" element={<AuditLogPage />} />
      <Route path="/app/workspace/:wsId/shared-links" element={<SharedLinksPage />} />

      {/* Admin */}
      <Route path="/admin" element={<AdminStatsPage />} />
      <Route path="/admin/users" element={<AdminUsersPage />} />
      <Route path="/admin/companies" element={<AdminCompaniesPage />} />
      <Route path="/admin/ai-runs" element={<AdminAiRunsPage />} />
      <Route path="/admin/ai-spend" element={<AdminAiSpendPage />} />
      <Route path="/admin/audit" element={<AdminAuditPage />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
